// cSpell:ignore AIzaSyAIwxmvex_by8rHyvFZGDRmvKFlQPwUQ7o, G7RVVM0VC1
const FirebaseConfig = {
  apiKey: 'AIzaSyDVTrgViKWvx1ubEpMeJn-8QFZnLIbGepM',
  authDomain: 'nflstatanalytics.firebaseapp.com',
  projectId: 'nflstatanalytics',
  storageBucket: 'nflstatanalytics.firebasestorage.app',
  messagingSenderId: '1007305121421',
  appId: '1:1007305121421:web:c725e5f989b29cbcb74cc4',
  measurementId: 'G-G7RVVM0VC1',
};

export { FirebaseConfig as default };
